import React from 'react';
import { Icon, Tooltip } from 'core/components';
import { observer } from 'mobx-react';
import BoardModel from '../../stores/boards/BoardModel';
import BoardPanelModel from '../../stores/boards/BoardPanelModel';

interface Props {
  board: BoardModel;
  panel?: BoardPanelModel;
}

/**
 * Renders a small blue dot indicating unsaved changes on a board or panel.
 * Replaces the prior orange "Draft" tag.
 */
function DraftTag({ board, panel }: Props) {
  const isDirty = panel ? panel.isDirty : board.isDirty;

  if (!isDirty) {
    return null;
  }

  return (
    <Tooltip content="You have unsaved changes">
      <Icon icon="dot" color="primary" iconSize={20} aria-label="Unsaved changes" />
    </Tooltip>
  );
}

export default observer(DraftTag);
